export default "__VITE_ASSET__96920c98__"